// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3smg3","modalForm":"UpgradeEpcsModal_modalForm__28GVd","modalFooter":"UpgradeEpcsModal_modalFooter__28c8p"};